module.exports = __webpack_public_path__ + "img/image-victor-glover.dbbfffcb.webp";